import { render, staticRenderFns } from "./SettlementAdjustmentList.vue?vue&type=template&id=17d2eb22&"
import script from "./SettlementAdjustmentList.vue?vue&type=script&lang=ts&"
export * from "./SettlementAdjustmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports